/**
 * Software keyboard mapping — the top computer-keyboard row plays a
 * synth channel (piano layout), and maps to drum rows on a drum channel.
 */

export const KEY_TO_NOTE: Record<string, number> = {
  a: 60, // C4
  w: 61,
  s: 62,
  e: 63,
  d: 64,
  f: 65,
  t: 66,
  g: 67,
  y: 68,
  h: 69,
  u: 70,
  j: 71,
  k: 72, // C5
  o: 73,
  l: 74,
  p: 75,
  ';': 76,
};

export const KEY_TO_DRUM: Record<string, number> = {
  a: 36, // kick
  w: 37, // rim
  s: 38, // snare
  e: 39, // clap
  d: 41, // tom H
  f: 43, // tom L
  t: 42, // chh
  g: 46, // ohh
};